module.exports = __webpack_public_path__ + "img/accepted-tick.3320a438.svg";